// EventModalUI.tsx
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { X, Edit, Trash2, MapPin, Clock } from "lucide-react";
import React from "react";
import { createPortal } from "react-dom"; // Add this import

import { formatEventTime } from "0.Mine/1.Hooks/utils/date";
import { Event } from "0.Mine/3.Interfaces/Event";

export interface EventModalUIProps {
  event: Event;
  onClose: () => void;
  onEdit: () => void;
  onDelete: (id: string) => void;
  styles: any; // Replace with proper type if desired
}

export const EventModalUI: React.FC<EventModalUIProps> = ({
  event,
  onClose,
  onEdit,
  onDelete,
  styles,
}) => {
  // Use createPortal to render the modal at the document root
  return createPortal(
    <Box
      sx={{
        ...styles.overlay,
        position: "fixed", // Force position fixed
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999, // Ensure it's above everything
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Box
        sx={{
          ...styles.container,
          position: "relative", // Explicitly set to relative
          margin: "auto", // Center in the overlay
          maxWidth: "500px", // Limit width
          width: "calc(100% - 32px)", // Full width minus margins
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the container
      >
        <Box sx={styles.header}>
          <Typography variant="h6" component="h2">
            {event.title}
          </Typography>
          <IconButton onClick={onClose} sx={styles.closeButton}>
            <X size={20} />
          </IconButton>
        </Box>
        <Box sx={styles.content}>
          <Box sx={styles.section}>
            <Clock size={20} style={styles.icon} />
            <Typography variant="body1" sx={styles.text}>
              {formatEventTime(event.start, event.end)}
            </Typography>
          </Box>
          {event.location && (
            <Box sx={styles.section}>
              <MapPin size={20} style={styles.icon} />
              <Typography variant="body1" sx={styles.text}>
                {event.location}
              </Typography>
            </Box>
          )}
          {event.description && (
            <Box sx={{ mb: 2, paddingTop: "10px", borderTop: "1px solid #ececec" }}>
              <Typography variant="body1" sx={styles.text}>
                {event.description}
              </Typography>
            </Box>
          )}
          <Box sx={styles.buttonContainer}>
            <Button
              onClick={() => onDelete(event.id)}
              sx={styles.deleteButton}
              startIcon={<Trash2 size={20} />}
            >
              Cancella
            </Button>
            <Button onClick={onEdit} sx={styles.editButton} startIcon={<Edit size={20} />}>
              Modifica
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>,
    document.body // Render directly to the document body
  );
};
